export default __webpack_public_path__ + "static/media/moth-insect-shape.c42c4a17.svg";